import script from "./EditSystemSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./EditSystemSetting.vue?vue&type=script&setup=true&lang=js"

import "./EditSystemSetting.vue?vue&type=style&index=0&id=e6ddbc7c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\digi_aj\\source\\repos\\1ANAB_Vue_Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6ddbc7c"]])

export default __exports__